import { useLayoutEffect, useState } from 'react';

// Viewport-x (px) of the PM content canvas's left edge — i.e. where the
// section sub-rail ends and the grid/roadmap begins. The left-side Done rail
// and peek tab are portaled to <body> with position:fixed, so without this
// they'd anchor to the viewport's left edge and paint over the global app nav
// + PM section rail. Anchoring to the canvas keeps them overlaying only the
// content area, mirroring how the right-side Backlog rail sits at the canvas's
// right (viewport) edge.
//
// Re-measures on viewport resize and on canvas resize — the latter fires when
// the global nav rail expands/collapses, which shifts the canvas sideways
// without a window resize event.
export function usePmCanvasLeft(): number {
  const [left, setLeft] = useState(0);

  useLayoutEffect(() => {
    const canvas = document.querySelector('.pm-canvas');
    if (!canvas) return;
    const measure = () => setLeft(canvas.getBoundingClientRect().left);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(canvas);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return left;
}
